import { RootState } from '../../../../rootReducer';

export const packingSelector = (state: RootState) => state.handbookModuleReducer.PackingReducer;
